import { FavouriteCondition, StoreField } from 'app/types-shared';
import { mapInitialConditionsValues } from './map-conditions-values';

export interface ConditionsValues extends StoreField {
  type?: string;
}

export const mapInitialConditions = (conditions: FavouriteCondition[] = []): ConditionsValues[] => {
  const values = conditions && conditions
    .map(condition => {
      return condition.values && condition.values.length > 0
        ? condition.values.map(value => mapInitialConditionsValues(condition.values, condition.advancedSearchType, value))
        : [];
    })
    .reduce((memo, curr) => [...memo, ...curr], []);

  return values && values.length ? values : undefined;
};
